<script setup lang="ts">
import { LuvButton } from "@polargold/luv-ui-library";
import { useI18n } from "vue-i18n";
import { useRouterPush } from "@/composable/useRouterPush";
import { ROUTE } from "@/router/routeDefinitions.ts";

const { t } = useI18n();
const { routerPush } = useRouterPush();

const goToStartPage = () => routerPush({ name: ROUTE.PRODUCT_SEARCH.NAME });
</script>

<template>
    <LuvButton
        button-style="secondary"
        inverted
        @click="goToStartPage"
        icon-before="fa-solid fa-arrow-left"
    >
        {{ t("COMPONENTS.CHECKOUT.GO_BACK_BUTTON") }}
    </LuvButton>
</template>